import logo from './logo.svg';
import './App.css';
import "./styles/colors.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

/** Componenti */
import DashboardLayout from "./components/DashboardLayout";

/** Pagine */
// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
import PassGenerator from "./pages/PassGenerator";
// import Orders from "./pages/Orders";
// import Profile from "./pages/Profile";
// import OrderPageSupplier from "./pages/OrderPageSupplier";
// import OrderDetail from "./pages/OrderDetail";
// import Elements from "./pages/Elements";

function App() {
  return (
		// <div className="App">
		//   <header className="App-header">
		//     <img src={logo} className="App-logo" alt="logo" />
		//     <p>
		//       Edit <code>src/App.js</code> and save to reload.
		//     </p>
		//     <a
		//       className="App-link"
		//       href="https://reactjs.org"
		//       target="_blank"
		//       rel="noopener noreferrer"
		//     >
		//       Learn React
		//     </a>
		//   </header>
		// </div>

		<Router>
			<Routes>
				{/* Pagina di login e registrazione come rotta indipendente */}
				{/* <Route path="/login" element={<Login />} /> */}
				{/* <Route path="/signup" element={<Signup />} /> */}

				{/* Rotte nidificate all'interno di DashboardLayout */}
				<Route path="/" element={<DashboardLayout />}>
					<Route path="passgenerator" element={<PassGenerator />} />
					{/* <Route index path="orders" element={<Orders />} />
					<Route path="profile" element={<Profile />} />
					<Route path="/orders/:id_order" element={<OrderDetail />} />
					<Route path="dashboard/elements" element={<Elements />} /> */}
				</Route>

				{/* Pagina indipendente fuori dal layout (es. senza sidebar) */}
				{/* <Route path="/orders/:id" element={<OrderPageSupplier />} /> */}
			</Routes>
		</Router>
	);
}

export default App;
